import UploadPosterIcon from 'components/icons/upload-poster/index.vue'
import AnimationProcessing from 'components/animations/processing'
import { UploadObject } from 'src/utils/objects/uploader'
import { mapGetters } from 'vuex'

export default {
  name: 'graphic-uploader',

  components: {
    UploadPosterIcon,
    AnimationProcessing
  },

  data () {
    return {
      uploader: UploadObject()
    }
  },

  props: {
    imageURL: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters('promotions', {
      uploading: ['uploading']
    })
  },

  methods: {
    setUploader () {
      if (this.imageURL.length === 0) {
        const $0 = this
        if (this.$el.querySelector('#qq-graphics-uploader-zone')) {
          this.uploader.create({
            context: this,
            target: '#qq-graphics-uploader-zone',
            handle: function () {
              $0.$store.dispatch('promotions/uploadPromoImage', {
                file: $0.uploader.getSubmits()[0]
              })
            }
          })
        }
      }
    }
  },

  mounted () {
    this.setUploader()
  },

  updated () {
    /*
     * Make sure the uploader is resetted in Template after render update.
     */
    this.setUploader()
  }
}
